import React from "react";
import "./best-seller.css";
import ficus from '../../../assets/best-ficus.jpeg'
import olives from '../../../assets/olive-best.jpeg';
import oak from '../../../assets/best-oak.jpeg'

interface PlantCardProps {
    name: string;
    image: string;
    description: string;
    isFeatured?: boolean;
}

const PlantCard: React.FC<PlantCardProps> = ({ name, image, description, isFeatured }) => (
    <div className={`plant-card ${isFeatured ? "featured" : ""}`} style={{width:"500px" , height:"auto"}}>
        <div className="rating">⭐⭐⭐⭐⭐ <span>(5/5)</span></div>
        {/* <div className="plus">+</div> */}
        <img src={image} alt={name} />
        <div className={`plant-info ${isFeatured ? "featured-info" : ""}`}>
            <h3>{name}</h3>
            <p>{description}</p>
        </div>
    </div>
);

const BestSellerPlants: React.FC = () => {
    return (
        <section className="best-seller-section">
            <h2>Our Best Seller Plant</h2>
            <p>
                Explore our most popular and highly rated trees, known for their beauty, resilience, and
                rich symbolism. These best sellers are perfect for both novice and seasoned plant lovers.
            </p>

            <div className="plant-cards" style={{marginTop:"5rem"}}>
                <PlantCard
                    name="Ficus Bonsai"
                    image={ficus}
                    description=" the Ficus Bonsai brings calmness to any indoor space. Easy to care for and visually elegant."
                    isFeatured
                />
                <PlantCard
                    name="Olive Tree"
                    image={olives}
                    description="Known for its longevity and symbolism of peace, the Olive Tree is a Mediterranean classic that thrives in sunlit spaces."
                    isFeatured
                />
                <PlantCard
                    name="Quercus Tree"
                    image={oak}
                    description="Quercus represents strength and endurance. Its majestic appearance make it a timeless outdoor favorite."
                    isFeatured
                />
            </div>
        </section>
    );
};

export default BestSellerPlants;
